import Vue from 'vue';
import Vuex from 'vuex';

import layout from './modules/layout'
import auth from './modules/auth'
import ga from './modules/google-analyticts'
import users from './modules/users'
import formatData from './modules/formatDataUser'
import networks from './modules/networks'
import scans from './modules/scans'
import tinderAccounts from './modules/tinderAccounts'
import analytic from './modules/analytic'
import discounts from './modules/discounts'
import discountCoupons from './modules/discountCoupons'
import monitor from './modules/monitor'
import posts from './modules/posts'
import category from './modules/category'
import tags from './modules/tags'
import authors from './modules/authors'
import media from './modules/media.js'

import tinderAccountsFilter from './modules/filters/tinderAccountsFilter';
import networkScansFilter from './modules/filters/networkScansFilter';
import usersPageFilter from './modules/filters/usersPageFilter';
import networkNetworksFilter from './modules/filters/networkNetworksFilter';
import postsFilter from './modules/filters/postsFilter';
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        layout,
        auth,
        ga,
        users,
        formatData,
        networks,
        scans,
        tinderAccounts,
        analytic,
        discounts,
        discountCoupons,
        monitor,
        tinderAccountsFilter,
        networkScansFilter,
        usersPageFilter,
        networkNetworksFilter,
        posts,
        postsFilter,
        category,
        tags,
        authors,
        media
    }
});